var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"auth-footer"},[_c('a',{staticClass:"auth-footer__link",attrs:{"href":"http://cleverstart.ru/"}},[_vm._v("© "+_vm._s(_vm.currentYear)+" CleverStart")])])}
var staticRenderFns = []

export { render, staticRenderFns }